import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'offer'
})
export class OfferPipe implements PipeTransform {

  transform(price: number, discount: number): any {
    if (discount) {
      price = (((100 + discount) / 100) * price);
    }

    return price.toFixed(2);
  }

}
